import { pino } from "pino/browser"

const logger = pino({
    level: import.meta.env.VITE_PINO_LEVEL || import.meta.env.VITE_LOG_LEVEL || "info",
})

export default logger
